import React, { ReactNode } from "react";
import { Link } from "react-router";
import { DailyIcon } from "@/features/daily/components/DailyIcon";
import { StatTile } from "@/features/daily/components/StatTile";
import type { StatTileVm } from "@/features/daily/components/stat-tile-view-model";

type Props = {
    tiles: StatTileVm[];
    queueHref: string;
    /** D134: the compact capability line shares the heading row, so it costs no height. */
    aside: ReactNode;
};

/**
 * FR-008: what is waiting now, as identical stat tiles in one row across the page (D134).
 * Money stays per currency and an absent figure is a dash with its reason.
 */
export const TodayOperations: React.FC<Props> = ({ tiles, queueHref, aside }) => (
    <section className="daily-today" aria-labelledby="daily-today-title">
        <div className="daily-panel__head">
            <h2 id="daily-today-title">Operaciones de hoy</h2>
            {aside}
            <Link className="daily-link" to={queueHref}>
                Ver operaciones <DailyIcon name="arrow_outward" />
            </Link>
        </div>
        <ul className="daily-tiles daily-today__cards">
            {tiles.map((tile) => <StatTile key={tile.key} tile={tile} idPrefix="daily-today-tip" />)}
        </ul>
    </section>
);
